// extracted by mini-css-extract-plugin
export var tosLink = "_63-0";